import Grid from "@mui/material/Grid";
import {Crumbs} from "../Crumbs.jsx";
import DayCalendar from "../DayCalendar.jsx";
import {useParams} from "react-router-dom";
import {Box} from "@mui/material";
import {OriginalCalendarButton} from "../Button/OriginalCalendarButton.jsx";
import {today} from "../../shared/date.js";
import {Helmet} from "react-helmet";
import React from "react";

const title = "Daily, Detailed Dance Calendar for Austin 2-Step For "
const desc = "Includes info about venues including cover charges, age restrictions, best days to vist, directions and what to expect"

const DailyCalendarPage = () => {

    const params = useParams();
    const date = params.date || today();

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <meta property="og:description" content={desc}/>
                <meta property="twitter:title" content={title + date}/>
                <meta property="twitter:description" content={desc}/>
                <title>{title + date}</title>
                <meta property="description" content={desc} />
                <link rel="canonical" href={`https://austin2step.com/calendar/${date}`} />
            </Helmet>
            <Grid container spacing={2}>
                <Grid item xs={12} >

                <Box style={{display:"flex", justifyContent:"space-between"}}>
                    <Crumbs crumbs={[
                        {href: "/where-to-dance", title: "Where to Dance"},
                        {href: "/calendar", title: "Detailed Calendar"}
                    ]}/>
                    <OriginalCalendarButton />
                </Box>

                </Grid>
                <Grid item xs={12}>
                    <DayCalendar date={date} />
                </Grid>
            </Grid>
        </div>
    );
}

export default DailyCalendarPage;